import { LomdaV3Content, LomdaV3Metadata } from "@/lib/utils/lomdaV3/types";

export type EditorMode = "edit" | "preview";

export interface LomdaV3EditorInit {
    userId: string;
    lomdaId: string;
    lomdaName: string;
    content: LomdaV3Content;
    metadata: LomdaV3Metadata;
}

/** Where a block sits: a container's slot (column / tab / step), or `null` for
 *  the page itself. */
export type BlockList = { containerId: string; slotId: string } | null;

export const sameBlockList = (a: BlockList, b: BlockList): boolean =>
    a === b ||
    (!!a && !!b && a.containerId === b.containerId && a.slotId === b.slotId);
